// import DrugSearchBar from "components/drugSearchBar";

import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

const AuthenticationGuardHoc = () => {
  const {
    UserStore: { isAuthenticated },
  } = useStore();
  const navigate = useNavigate();

  // check if not authenticated navigate to the home screen
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div>
      {/* show children only if authenticated */}
      {isAuthenticated && <Outlet />}
    </div>
  );
};

export default AuthenticationGuardHoc;
